import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard } from '~/core/PermissionGuard';
import { ValleyBankPermissionsFn } from '~/core/routes/valley-bank/types';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditAgreementSectionWip } from '~/packages/creditAgreements/ui/creditAgreementWip/CreditAgreementWip';
import { useDataMetadataContext } from '~/valleyBank/domains/page/hooks/DataMetadataContext';
import { useUserRoleTypePermissionsContext } from '~/valleyBank/domains/page/hooks/useUserRoleTypePermissions';

// Fragments
const RouteBase = () => {
  const { creditFacilityId } = useCreditFacilityContext();
  return (
    <CreditAgreementSectionWip
      creditFacilityId={creditFacilityId}
      section="borrowingBaseMechanics"
    />
  );
};

// Exports
export const valleyPermissions: ValleyBankPermissionsFn = (context) => {
  if (context.dashboardMode === 'historical') return 'deny';
  if (!context.permissions.advanceRateRead) return 'deny';
  return 'allow';
};
export const Route = () => {
  const { dashboardMode } = useDataMetadataContext();
  const { permissions } = useUserRoleTypePermissionsContext();
  return (
    <PermissionGuard
      permissions={() => valleyPermissions({ dashboardMode, permissions })}
      fallback={<Navigate to="./loan-accounts" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="./loan-accounts" />;
        }}
      >
        <RouteBase />
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
